import React, { useState } from 'react'
import barcode1 from "./assets/barcode1.webp";
import barcode2 from "./assets/barcode2.webp";
import upiLogo from './assets/upiLogo.jpeg'



const Qrcodes = () => {

  const [copiedText, setCopiedText] = useState(null);
  const copyToClipboard = async (text, id) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(text);
        setCopiedText(id);
        setTimeout(() => setCopiedText(null), 2000);
      } else {
        alert("Copy functionality is not supported in this browser.");
      }
    } catch (error) {
      console.error("Failed to copy text: ", error);
      alert("Failed to copy. Please try again.");
    }
  };
  return (
    <div>

      {/* donation Through Bank */}
      <div className="mx-2 md:mt-20 mt-12 md:w-[99%] w-[96%]">
        <div className="md:mx-44  md:border-5 border-2 md:rounded-2xl rounded-lg border-[#C61D21] mt-1 justify-center items-center  overflow-hidden">
          <h2 className="md:py-4 py-3 bg-[#C61D21] text-white text-center md:text-3xl text-base">
            Donation Through Bank (NEFT/RTGS){" "}
          </h2>
          <div className="flex justify-center items-center">
            <ul className="flex flex-col justify-center items-center leading-4 space-y-4 list-none px-0 mx-0  my-2">
              <li className="w-full md:text-2xl text-[15px]  leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal">
                <span className="md:text-2xl text-[15px] text-[#C61D21] ">
                  Bank Name:<span className="text-black"> HDFC Bank</span>
                </span>{" "}
                <button
                  class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5 border-1 border-[#C61D21] ml-2 rounded-full"
                  onClick={() => copyToClipboard("HDFC Bank", "bankName")}
                >
                  {copiedText === "bankName" ? "Copied!" : "Copy"}
                </button>
              </li>

              <li className="w-full md:text-2xl text-[15px]  leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal">
                <span className="md:text-2xl text-[15px] text-[#C61D21]">
                  Account Name:<span className="text-black"> ISKCON</span>
                </span>{" "}
                <button
                  class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5  border-1 border-[#C61D21] ml-2 rounded-full"
                  onClick={() => copyToClipboard("ISKCON", "accountName")}
                >
                  {copiedText === "accountName" ? "Copied!" : "Copy"}
                </button>
              </li>
              <li className="w-full md:text-2xl text-[15px]  leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal">
                <span className=" text-[#C61D21]">
                  Account Number:{" "}
                  <span className="text-black">50100436709020</span>
                </span>{" "}
                <button
                  class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5 border-1 border-[#C61D21] ml-2 rounded-full"
                  onClick={() =>
                    copyToClipboard("50100436709020", "accountNumber")
                  }
                >
                  {copiedText === "accountNumber" ? "Copied!" : "Copy"}
                </button>
              </li>
              <li className="w-full md:text-2xl text-[15px]  leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal ">
                <span className=" text-[#C61D21]">
                  IFSC Code: <span className="text-black">HDFC000568</span>
                </span>
                <button
                  class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5 border-1 border-[#C61D21] ml-2 rounded-full"
                  onClick={() => copyToClipboard("HDFC000568", "ifscCode")}
                >
                  {copiedText === "ifscCode" ? "Copied!" : "Copy"}
                </button>
              </li>
              <li className="w-full md:text-2xl text-[15px] leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal">
                <span className=" text-[#C61D21]">
                  Branch:{" "}
                  <span className="text-black">ONE TOWN VIJAYAWADA </span>
                </span>{" "}
                <button
                  class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5 border-1 border-[#C61D21] ml-2 rounded-full"
                  onClick={() =>
                    copyToClipboard("ONE TOWN VIJAYAWADA", "branch")
                  }
                >
                  {copiedText === "branch" ? "Copied!" : "Copy"}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* UPI Payment */}
      <div className="mx-2 ">
        <div className="md:mx-44  md:border-5 border-2 md:rounded-2xl rounded-lg border-[#C61D21] mt-10 overflow-hidden">
          <h2 className="md:py-4 py-2 bg-[#C61D21] text-white text-center md:text-3xl text-base">
            Donate Through UPI
          </h2>

          <div className="flex md:flex-row flex-col justify-around items-center pt-3 md:pb-3 pb-4 gap-4">
            <div className="md:flex md:flex-col flex  flex-col text-center gap-2 px-1">
              <span className='flex md:justify-start justify-center items-center gap-4 '><img src={upiLogo} alt="upiLogo" />(ISKCON)</span>
              <span className='flex items-center md:justify-start justify-center gap-2'>
                <h2 className="md:text-2xl text-sm text-[#C61D21] ">UPI ID:</h2>
                <p className="md:text-xl text-sm  text-black relative top-1">
                  {" "}
                  iskconvijayawada@idfcbank
                </p>
                <button
                  class="bg-gray-200 md:text-xs text-[10px]  text-black px-2 md:py-0.5 border-1 border-[#C61D21] ml-2 rounded-full font-bold"
                  onClick={() =>
                    copyToClipboard("iskconvijayawada@idfcbank", "upiId")
                  }
                >
                  {copiedText === "upiId" ? "Copied!" : "Copy"}
                </button>
              </span>

              <span>
                (Use for Google Pay, BHIM, PhonePe, Paytem and other UPI Apps)
              </span>
            </div>
            <img
              loading="lazy"
              src={barcode1}
              alt=""
              width="200px"
              height="200px"
            />
            <span className="font-bold ">OR</span>
            <img
              loading="lazy"
              src={barcode2}
              alt=""
              width="200px"
              height="200px"
            />
          </div>
        </div>

        <div className="text-left md:mx-44 mt-5 pb-10">
          <h2 className="text-3xl  text-[#C61D21] text-left font-bold">
            After Donation:
          </h2>
          <p className="md:text-2xl mt-4 text-base text-black w-full text-justify font-semibold">
            Once you have donated, please share the transaction details or
            receipt via WhatsApp at{" "}
            <span className="text-red">+91 9955685568</span>. This helps us
            acknowledge your contribution and issue a receipt for tax
            exemption under Section 80G of the Income Tax Act.
          </p>

        </div>
      </div>
    </div>
  );
}

export default Qrcodes
